export const PERMS = {
    READ: 'report_empty_kilometers.read',
    UPDATE: 'report_empty_kilometers.update',
    DELETE: 'report_empty_kilometers.delete',
    CREATE: 'report_empty_kilometers.create',
}
